import { index, pgTable, text, uuid } from "drizzle-orm/pg-core";
import { createInsertSchema, createSelectSchema } from "drizzle-zod";
import z from "zod";

import { coverageChecksTable } from "./coverageChecksSchema";
import { customTimestamp } from "./utils/types";

export const coverageCheckServiceTypesTable = pgTable(
  "coverage_check_service_types",
  {
    id: uuid("id").primaryKey().defaultRandom(),
    coverageCheckId: uuid("coverage_check_id")
      .references(() => coverageChecksTable.id, { onDelete: "cascade" })
      .notNull(),
    code: text("code").notNull(),
    name: text("name").notNull(),
    description: text("description"),
    createdAt: customTimestamp("created_at")
      .notNull()
      .$defaultFn(() => new Date().toISOString()),
    updatedAt: customTimestamp("updated_at")
      .notNull()
      .$defaultFn(() => new Date().toISOString())
      .$onUpdateFn(() => new Date().toISOString()),
  },
  table => [
    index("coverage_check_service_types_coverage_check_id_idx").on(
      table.coverageCheckId,
    ),
  ],
);

export const coverageCheckServiceTypeSelectSchema = createSelectSchema(
  coverageCheckServiceTypesTable,
);

export type CoverageCheckServiceTypeSelectType = z.infer<
  typeof coverageCheckServiceTypeSelectSchema
>;

export const insertCoverageCheckServiceTypeSchema = createInsertSchema(
  coverageCheckServiceTypesTable,
).omit({ createdAt: true, updatedAt: true });

export type InsertCoverageCheckServiceTypeType = z.infer<
  typeof insertCoverageCheckServiceTypeSchema
>;

export const updateCoverageCheckServiceTypeSchema =
  insertCoverageCheckServiceTypeSchema.omit({
    id: true,
    coverageCheckId: true,
  });

export type UpdateCoverageCheckServiceTypeType = z.infer<
  typeof updateCoverageCheckServiceTypeSchema
>;
